<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
      <v-radio-group
        v-if="isWarehouseSelectionAvailable"
        v-model="form.warehouse_assignment"
        column
      >
        <v-radio
          label="Usa magazzino default"
          :value=0
        ></v-radio>
        <v-radio
          label="Crea magazzino per il propagandista"
          :value=2
        ></v-radio>
        <v-radio
          v-if="hasAvailableWarehouses"
          label="Assegna magazzino esistente"
          :value=1
        ></v-radio>
      </v-radio-group>
      <ValidationProvider
            rules="required"
            vid="warehouse_id"
            :name="$t('fields.warehouse').toLowerCase()"
            v-slot="{ errors }"
            v-if="form.warehouse_assignment === 1"
        >
          <WarehouseAvailablesSelect
            v-model=" form.warehouse_id"
            :counter="30"
            :label="$t('fields.warehouse')"
            :error-messages="errors"
          ></WarehouseAvailablesSelect>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="surname"
            :name="$t('fields.surname').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.surname"
            :counter="30"
            :label="$t('fields.surname')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="name"
            :name="$t('fields.name').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.name"
            :counter="30"
            :label="$t('fields.name')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="phone"
            :name="$t('fields.phone').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.phone"
            :counter="15"
            :label="$t('fields.phone')"
            :error-messages="errors"
          ></v-text-field>
      </ValidationProvider>
      <ValidationProvider
            rules="required"
            vid="address"
            :name="$t('fields.address').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.address"
            :counter="50"
            :label="$t('fields.address')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="city"
            :name="$t('fields.city').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.city"
            :counter="50"
            :label="$t('fields.city')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="born_date"
            :name="$t('fields.born_date').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.born_date"
                :label="$t('fields.born_date')"
                readonly
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="form.born_date"
              :max="new Date().toISOString().substr(0, 10)"
              min="1950-01-01"
              @change="saveDate"
            ></v-date-picker>
          </v-menu>
        </ValidationProvider>
      <ValidationProvider
            rules="required|email|confirmed:email_confirmation"
            vid="email"
            :name="$t('fields.email').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.email"
            :counter="255"
            :label="$t('fields.email')"
            :error-messages="errors"
          ></v-text-field>
      </ValidationProvider>
      <ValidationProvider
            rules="required|email"
            vid="email_confirmation"
            :name="$t('fields.email_confirmation').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-text-field
          v-model=" form.email_confirmation"
          :counter="255"
          :label="$t('fields.email_confirmation')"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
      <ValidationProvider
            :rules="passwordRule"
            vid="password"
            :name="$t('fields.password').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-text-field
          v-model=" form.password"
          :type="'password'"
          :label="$t('fields.password')"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
      <ValidationProvider
            vid="password_confirmation"
            :name="$t('fields.password_confirmation').toLowerCase()"
            v-slot="{ errors }"
      >
        <v-text-field
          v-model=" form.password_confirmation"
          :type="'password'"
          :label="$t('fields.password_confirmation')"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { propagandistsService } from '../../../utils/services/propagandists.service';
  import { warehousesService } from '../../../utils/services/warehouses.service';
  import WarehouseAvailablesSelect from '../../shared/Vselects/WarehouseAvailablesSelect.vue';

  export default {
    name: 'PropagandistModal',
    components: { WarehouseAvailablesSelect },
    data() {
      return {
        stored: null,
        user: {},
        passwordRule: 'required|min:8|confirmed:password_confirmation',
        menu: null,
        form: {
          warehouse_assignment: 1,
          warehouse_id: null,
          name: null,
          surname: null,
          email: null,
          email_confirmation: null,
          phone: null,
          password: null,
          password_confirmation: null,
          born_date: null,
          city: null,
          address: null,
        },
        hasAvailableWarehouses: false,
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      isWarehouseSelectionAvailable() {
        return !Object.keys(this.user).length;
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      saveDate(date) {
        this.$refs.menu.save(date);
      },
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      fetchPropagandist(id) {
        return propagandistsService.get(id)
        .then(response => {
            this.user = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchAvailableWarehouses() {
        return warehousesService.index({
          propagandist_id: 0,
          is_default: 0,
        })
        .then(response => {
            this.hasAvailableWarehouses = (response.data.data.length > 0);
            if (!this.hasAvailableWarehouses && this.form.warehouse_assignment === 1) {
              this.form.warehouse_assignment = 0;
            }
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored.id) {
        this.passwordRule = 'min:8|confirmed:password_confirmation';
        await this.fetchPropagandist(this.data.stored.id);
        const bornDate = (this.user.options && this.user.options.born_date) ? this.user.options.born_date : '';
        this.form = {
          id: this.data.stored.id,
          name: this.user.name,
          surname: this.user.surname,
          phone: this.user.phone,
          email: this.user.email,
          email_confirmation: this.user.email,
          address: (this.user.options && this.user.options.address) ? this.user.options.address : '',
          city: (this.user.options && this.user.options.city) ? this.user.options.city : '',
          born_date: bornDate,
        };
        this.menu = bornDate;
        this.saveDate(bornDate);
      } else {
        await this.fetchAvailableWarehouses();
      }
      this.loadingModal(false);
    },
    watch: {
      menu(val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
      },
    },
  };
</script>
